import React from "react";

/**
 * One slow editorial marquee. The phrase sequence is rendered once; the second
 * copy is aria-hidden and exists only to make the loop seamless.
 */
export function Marquee({ items }) {
  const phrase = items.join("  —  ") + "  —  ";
  return (
    <div
      className="relative border-y border-[#2A2A36] bg-[#0F0F14] py-4 sm:py-5 overflow-hidden"
      role="marquee"
      aria-label={items.join(", ")}
    >
      <div className="flex w-max animate-marquee">
        <span className="whitespace-nowrap font-display font-bold uppercase tracking-[0.18em] text-lg sm:text-2xl text-white/90 pr-4">
          {phrase}
        </span>
        <span className="whitespace-nowrap font-display font-bold uppercase tracking-[0.18em] text-lg sm:text-2xl text-white/90 pr-4" aria-hidden="true">
          {phrase}
        </span>
      </div>
    </div>
  );
}
